module.exports = __webpack_public_path__ + "img/product_29.8d98571.webp";